import React, { useEffect, useState } from "react";
import {
  BiCalendar,
  BiCar,
  BiGasPump,
  BiKey,
  BiPalette,
  BiShield,
  BiPound,
} from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getCarsById } from "../store/car/actions/actionsCreators";
import CarDetailsSlider from "./CarDetailsSlider";
import { MdGasMeter } from "react-icons/md";
import VideoModal from "./VideoModal";
import { LuImageOff } from "react-icons/lu";
import CarGallery from "./CarGallery";
import CarPurchaseModel from "../Models/CarPurchaseModel";
const Url = process.env.REACT_APP_SERVER_URL;

const CarDetail = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [show, setShow] = useState(false);
  const [carTitle, setCarTitle] = useState("");
  const { carDetails } = useSelector((state) => state.car);
  carDetails.videoUrl = "https://www.youtube.com/embed/dQw4w9WgXcQ";
  const { id } = useParams();
  const Dispatch = useDispatch();
  useEffect(() => {
    Dispatch(getCarsById(id));
  }, [Dispatch, id]);

  return (
    <>
      <CarDetailsSlider carDetails={carDetails} />
      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-0 shadow-sm rounded">
              {carDetails?.featuredImage ? (
                <img
                  src={`${Url}/${carDetails.featuredImage}`}
                  alt="Car"
                  className="card-img-top object-fit-cover"
                  style={{ height: "auto", borderRadius: "0.5rem" }}
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "300px" }}
                >
                  <LuImageOff size={48} className="text-secondary" />
                  <p className="ms-2">No Image Available</p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 d-flex flex-column">
            <div>
              <span className="badge bg-primary">{carDetails?.modalYear}</span>
              <h2 className="fw-bold mt-2">{carDetails?.title}</h2>
              <p className="">{carDetails?.shortDescription}</p>
              <p>
                <strong>Mileage:</strong> {carDetails?.miles} miles
              </p>
              <p>
                <strong>Year:</strong> {carDetails?.modalYear}
              </p>
              <p>
                <strong>Price:</strong> £{carDetails?.carPrice}
              </p>
            </div>
            {carDetails?.carVideo && (
              <div className="mt-3">
                <button
                  className="btn style2"
                  onClick={() => setShowVideo(!showVideo)}
                >
                  🎥 Watch Video
                </button>
              </div>
            )}
            {carDetails?.imageGallery?.length > 0 && (
              <div className="mt-3">
                <button
                  className="btn btn-dark"
                  onClick={() => setShowGallery(true)}
                >
                  🖼️ View Gallery
                </button>
              </div>
            )}
            <div className="mt-3">
              <button
                className="btn btn-dark"
                onClick={() => {
                  setShow(true);
                  setCarTitle(carDetails?.title);
                }}
              >
                Buy Now
              </button>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <h4>Description</h4>
          <p className="text-muted">{carDetails?.description}</p>
        </div>
        <div className="mt-5">
          <h4 className="mb-3">Car Features</h4>
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
            {[
              {
                icon: <BiCalendar color="#D74F1C" size={40} />,
                label: carDetails?.modalYear,
              },
              {
                icon: <MdGasMeter color="#D74F1C" size={40} />,
                label: `${carDetails?.miles} miles`,
              },
              {
                icon: <BiCar color="#D74F1C" size={40} />,
                label: carDetails?.gearTypes,
              },
              {
                icon: <BiGasPump color="#D74F1C" size={40} />,
                label: carDetails?.fuelTypes,
              },
              {
                icon: <BiPalette color="#D74F1C" size={40} />,
                label: carDetails?.color,
              },
              {
                icon: <BiShield color="#D74F1C" size={40} />,
                label: `Insurance ${carDetails?.insuranceGroup}`,
              },
              {
                icon: <BiKey color="#D74F1C" size={40} />,
                label: `Previous Owner ${carDetails?.previousOwner}`,
              },
              {
                icon: <BiPound color="#D74F1C" size={40} />,
                label: `Vehicle Tax ${
                  carDetails?.vehicleTax ? carDetails?.vehicleTax : ""
                }`,
              },
            ].map((item, i) => (
              <div key={i} className="col">
                <div className="bg-black border rounded p-3 text-center shadow-sm h-100 text-white">
                  <div
                    className="text-white mb-2"
                    style={{ fontSize: "1.4rem" }}
                  >
                    {item.icon}
                  </div>
                  <small className="text-white fw-bold">{item.label}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="container my-5">
          <h4 className="mb-4">Additional Car Information</h4>
          <div className="row">
            {carDetails?.dimensions?.length > 0 && (
              <div className="col-md-6 mb-4">
                <div
                  className="p-4 rounded text-white"
                  style={{ backgroundColor: "#D74F1C" }}
                >
                  <h5 className="text-white">Dimensions</h5>
                  <ul className="mb-0 ps-3">
                    {carDetails?.dimensions.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {carDetails?.weights?.length > 0 && (
              <div className="col-md-6 mb-4">
                <div
                  className="p-4 rounded text-white"
                  style={{ backgroundColor: "#D74F1C" }}
                >
                  <h5 className="text-white">Weights</h5>
                  <ul className="mb-0 ps-3">
                    {carDetails?.weights.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {carDetails?.safety?.length > 0 && (
              <div className="col-md-6 mb-4">
                <div
                  className="p-4 rounded text-white"
                  style={{ backgroundColor: "#D74F1C" }}
                >
                  <h5 className="text-white">Safety</h5>
                  <ul className="mb-0 ps-3">
                    {carDetails?.safety.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {carDetails?.keyFeatures &&
              Object.entries(carDetails.keyFeatures).map(
                ([key, values]) =>
                  values.length > 0 && (
                    <div className="col-md-6 mb-4" key={key}>
                      <div
                        className="p-4 rounded text-white"
                        style={{ backgroundColor: "#D74F1C" }}
                      >
                        <h5 className="text-white">
                          {key
                            .replace(/([A-Z])/g, " $1")
                            .trim()
                            .toLowerCase()
                            .replace(/^./, (char) => char.toUpperCase())}
                        </h5>
                        <ul className="mb-0 ps-3">
                          {values.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )
              )}
            {carDetails?.performance &&
              Object.entries(carDetails.performance).map(
                ([key, values]) =>
                  values.length > 0 && (
                    <div className="col-md-6 mb-4" key={key}>
                      <div
                        className="p-4 rounded text-white"
                        style={{ backgroundColor: "#D74F1C" }}
                      >
                        <h5 className="text-white">
                          {key
                            .replace(/([A-Z])/g, " $1")
                            .trim()
                            .toLowerCase()
                            .replace(/^./, (char) => char.toUpperCase())}
                        </h5>
                        <ul className="mb-0 ps-3">
                          {values.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )
              )}
          </div>
        </div>

        <div className="alert alert-primary mt-4">
          <strong>Note:</strong> Fresh stock arriving soon. More photos and
          videos will be uploaded.
        </div>
      </div>
      {showGallery && (
        <CarGallery carDetails={carDetails} setShowGallery={setShowGallery} />
      )}

      {showVideo && (
        <VideoModal
          videoUrl={carDetails?.carVideo}
          setShowVideoModal={setShowVideo}
        />
      )}
      <CarPurchaseModel
        carTitle={carTitle}
        showModal={show}
        setShowModal={setShow}
      />
    </>
  );
};

export default CarDetail;
